export const TOASTER_SUCCESS = 'TOASTER_SUCCESS'
export const TOASTER_ERROR = 'TOASTER_ERROR'
export const TOASTER_INFO = 'TOASTER_INFO'
export const TOASTER_WARNING = 'TOASTER_WARNING'
export const SIDEBAR_CALLAPSED = 'SIDEBAR_CALLAPSED'